import type { FlowDefinition } from '../types/index.js';
import { createSentryTriageFlow } from './sentry-triage-flow.js';
import { createLinearDevFlow } from './linear-dev-flow.js';

/** One gallery template: `id` is the stable key both surfaces use; `create` builds a fresh `FlowDefinition`. */
export interface GalleryTemplate {
  id: string;
  create: (id: string) => FlowDefinition;
}

/**
 * The canonical templates the gallery offers — the single source for both
 * surfaces. The server route derives required plugins from `create(id)`; the web
 * picker builds its preview from the same factory. Add templates here (plus a
 * display entry keyed by id), not in a parallel list.
 */
export const GALLERY_TEMPLATES = [
  { id: 'sentry-triage', create: createSentryTriageFlow },
  { id: 'linear-dev', create: createLinearDevFlow },
] as const satisfies ReadonlyArray<GalleryTemplate>;

/** Stable id union of the gallery templates; drives the web display map. */
export type GalleryTemplateId = (typeof GALLERY_TEMPLATES)[number]['id'];
